export const WHATS_APP_ACCOUNTS_KEY = "/engagement/:app_group_id/whats_app/accounts" as const;
